import { GridContainer } from 'libs/ui';
import { Role } from 'grids/role/role';

export const RoleWrapper = (props) => {
  return (
    <GridContainer>
      <Role {...props} />
    </GridContainer>
  );
};
